import jQuery from 'jquery';

(function ($) {
    let toggled = false;

    function hamburgerClick() {
        let mobileMenu = $('.mobile-menu-container');
        let body = $('body');

        body.toggleClass('nav--toggled');
        body.toggleClass('overflow-hidden');
        mobileMenu.toggleClass('mobile-menu-container--visible');
        $(this).toggleClass('nav--toggled');
        toggled = !toggled;
    }

    function mobileMenuClick(e) {
        const menuItem = $(e.target).closest('.menu-item-has-children.level-0');

        if (menuItem.length && !$(e.target).closest('.mobile-nav__submenu').length) {
            e.preventDefault();
            if (menuItem.hasClass('mobile-nav__menu-item--active')) {
                $('.mobile-nav').scrollTop(0);
                menuItem.find('.mobile-nav__submenu').stop().slideUp(300);
                menuItem.removeClass('mobile-nav__menu-item--active');
            } else {
                $('.mobile-nav__submenu').each(function () {
                    $('.mobile-nav').scrollTop(0);
                    $(this).stop().slideUp(300);
                    $(this).closest('.menu-item-has-children.level-0').removeClass('mobile-nav__menu-item--active');
                });
                menuItem.find('.mobile-nav__submenu').stop().slideDown(300);
                menuItem.addClass('mobile-nav__menu-item--active');
            }
        }
    }

    $(document).ready(function () {
        $('.hamburger').on('click', hamburgerClick);
        $('.level-0.current-menu-parent').each(function () {
            $(this).addClass('mobile-nav__menu-item--active');
        });
        $('.mobile-nav__menu-item.level-0.menu-item-has-children').on('click', mobileMenuClick);

        $(window).resize(function () {
            let hamburger = $('.hamburger');

            if ($(window).width() >= 1024 && hamburger.hasClass('nav--toggled')) {
                hamburger.trigger('click');
            }
        });
    })
})(jQuery);